var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.password),expression:"item.password"}],attrs:{"type":"password","placeholder":_vm.item.placeholder,"autocomplete":"on"},domProps:{"value":(_vm.item.password)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.item, "password", $event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }